import { useTranslation } from 'react-i18next';

/**
 * Inhalt des Bootstrap-Slots: dezenter Skeleton während der Tenant-Config
 * geladen wird. Bewusst kein Animations-Theater — der Fetch ist typischerweise
 * unter 200 ms, also reicht ein ruhiger Platzhalter, keine Spinner-Show.
 */
export function BootstrapSkeleton(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex h-screen w-full items-center justify-center bg-background text-foreground"
    >
      <span className="sr-only">{t('bootstrap.loading')}</span>
      <span
        aria-hidden="true"
        className="block h-10 w-10 animate-spin rounded-full border-[3px] border-brand/20 border-t-brand"
      />
    </div>
  );
}
